import type { Settings } from '../types';
import { Storage } from './storage.ts';

const SETTINGS_KEY = 'kf-settings';
const LEGACY_SETTINGS_KEY = 'kairofocus_settings';

export const defaultSettings: Settings = {
  workDuration: 25,
  shortBreakDuration: 5,
  longBreakDuration: 15,
  longBreakInterval: 4,
  activeMethod: 'pomodoro',
  autoStartBreaks: false,
  autoStartWork: false,
  soundEnabled: true,
  volume: 50,
  workCompleteSound: '/audio/beep-alarm.mp3',
  breakCompleteSound: '/audio/beep-alarm.mp3',
  theme: 'system',
  accent: 'default',
  bgPreset: 'warm-stone',
  density: 'cozy',
  showCompletedTasks: false,
  taskPanelCollapsed: true,
  activeProvider: 'local',
  intentionPromptEnabled: true,
  reflectionPromptEnabled: true,
};

const migrateIfNeeded = (): void => {
  if (!localStorage.getItem(SETTINGS_KEY) && localStorage.getItem(LEGACY_SETTINGS_KEY)) {
    const raw = localStorage.getItem(LEGACY_SETTINGS_KEY)!;
    localStorage.setItem(SETTINGS_KEY, raw);
    localStorage.removeItem(LEGACY_SETTINGS_KEY);
  }
};

export const loadSettingsFromLocalStorage = (): Settings => {
  migrateIfNeeded();
  return { ...defaultSettings, ...Storage.read<Partial<Settings>>(SETTINGS_KEY, {}) };
};

export const saveSettingsToLocalStorage = (settings: Settings): void => {
  Storage.write(SETTINGS_KEY, settings);
};

export const clearSettingsFromLocalStorage = (): void => {
  Storage.remove(SETTINGS_KEY);
};
